import urlJoin from "url-join";

import apiConfig from "../../../../config/apis";

/**
 * Base URL for Postal Location API.
 *
 * @type {string}
 */
export const baseApiUrl = urlJoin(
  apiConfig.urls.hosts.postalLocationBaseUrl,
  apiConfig.urls.endpoints.locationAutocomplete
);

/**
 * The name of the city and postal code field.
 *
 * @type {string}
 */
export const CITY_AND_POSTAL_CODE = "cityAndPostalCode";
